export const formatDate = (date) => {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0") +
    "T" +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0") +
    ":" +
    String(date.getSeconds()).padStart(2, "0") +
    "." +
    String(date.getMilliseconds()).padStart(3, "0")
  );
};

export const formatDateUTC = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    timeZone: "UTC",
  });

export const formatTimeUTC = (date) => {
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};

export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(",")[1]); // Decode Base64
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  return new Blob([new Uint8Array(byteArrays)], { type: mimeType });
};

export const generateEmailBody = (
  lastName,
  formattedDateUTC,
  formattedStartTimeUTC,
  formattedEndTimeUTC,
  blobToImgApi,
  getUserEmployee
) => `
    <html>
        <body style="font-family: Arial, sans-serif; color: #000;">
            <p>Good day, ${lastName}!</p>
            <p>Greetings from <strong>LGS Staff Management Services Incorporated</strong>!</p>
            <p>My name is ${
              getUserEmployee?.sex === "Male" ? "Mr." : "Ms."
            } <strong>${
  getUserEmployee.firstName
}</strong>, HR/Recruitment Officer of LGS Staff Management Services Incorporated. Thank you for showing interest in applying with our company. After viewing your application, I am pleased to invite you for an initial interview to further discuss your application. Please refer to the following details:</p>
            <p><strong>When:</strong> ${formattedDateUTC}</p>
            <p><strong>Time:</strong> Between ${formattedStartTimeUTC} - ${formattedEndTimeUTC}</p>
            <p><strong>Where:</strong> G/F P.E.S Bldg. <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian St.</a> cor. Rockefeller St. Brgy. San Isidro, Makati City</p>
            <p><strong>Attire:</strong> Formal/Corporate</p>
            <p>Kindly bring your most updated resume, valid ID, and black ballpen. Please reply with your full name in this email as confirmation of your attendance.</p>
            <p>Here is your interview QR Code:</p>
            <img src="${
              blobToImgApi?.url
            }" alt="QR Code" width="200" height="200" />
            <p>Thank you very much and see you!</p>
            <p>Sincerely yours,</p>
            <p><strong>${getUserEmployee?.firstName} ${
  getUserEmployee?.middleName
}. ${getUserEmployee?.lastName}</strong><br>
            Recruitment Officer<br>
            <strong>LGS Staff Management Services Inc.</strong><br>
            <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian St.</a>, Brgy. San Isidro, Makati City, 1234 Philippines</p>
        </body>
    </html>
  `;

export const generateOnboardEmail = (firstname, date, time) => `
  <html>
    <body style="font-family: Arial, sans-serif; color: #000;">
      <p>Dear ${firstname},</p>
      <p>Congratulations and welcome to LGS Staff Management Services Incorporated!
          We’re pleased to inform you that you have successfully passed the initial interview and have been selected to proceed with the onboarding process as part of our team.
          Please see the onboarding details below:
      </p>
      <p><strong>When: </strong>${date}</p>
      <p><strong>Time: </strong>${time}</p>
      <p><strong>Where:</strong> LGS Centre, <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian corner</a>, Rockefeller St. Brgy. San Isidro, Makati City, 1234 Philippines</p>
      <p><strong>Attire: </strong>Formal/Corporate</p>
      <strong>Reminders:</strong>
      <p>Please log in to the LGS Portal using the same credentials you used during your application before reporting onsite.</p>
      <p>Best Regards,</p>
      <p style="margin: 0;">LGS Staff Management Services Incorporated</p>
      <p style="margin: 0;">
        LGS Centre, <a href="https://maps.google.com/?q=1639+Dian+St,+Makati" target="_blank">1639 Dian</a> corner, Rockefeller St. Brgy. San Isidro, Makati City, 1234 Philippines
      </p>
      <p style="margin: 0;">Telephone No: (02) 8889-2680</p>
      <p style="margin: 0;">
        Facebook: <a href="https://www.facebook.com/LGSSTAFF" target="_blank">https://www.facebook.com/LGSSTAFF</a>
      </p>
      <p style="margin: 0;">
        Website: <a href="https://www.lgsstaff.com" target="_blank">www.lgsstaff.com</a>
      </p>
      <p style="margin-top:0;">"Our job is to make your job easier"</p>
      
      <i style="font-size:0.7rem">The content of this email is confidential and intended for the recipient specified in the message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.</i>
      <div style="display:flex">
        <img src="https://dev.lgs.mweeb.com/LGS_email_left.png" alt="LGS Logo Left" width="100" height="100" style="display:block;object-fit:contain;">
        <img src="https://dev.lgs.mweeb.com/LGS_email_right.jpg" alt="LGS Logo Right" width="100" height="100" style="display:block;object-fit:contain;">
      </div>

    </body>
  </html>
    `;
